import { useEffect, useState } from "react";
import { Wrench, ChevronDown } from "lucide-react";
import { useApi } from "@/lib/api";
import { t } from "@/i18n";

const usd = (n) => `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
const day = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

export function useRepairSpend(enabled) {
  const api = useApi();
  const [data, setData] = useState(null);
  useEffect(() => { if (enabled) api.get("/repairs/summary").then((r) => setData(r.data)).catch(() => {}); }, [api, enabled]);
  return data;
}

export function RepairSpend({ row, year }) {
  const [open, setOpen] = useState(false);
  if (!row) return null;
  return (
    <div className="rounded-xl border border-[var(--border-color)]" data-testid={`repair-spend-${row.property_id}`}>
      <button className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left" onClick={() => setOpen(!open)} aria-expanded={open} data-testid={`repair-spend-toggle-${row.property_id}`}>
        <Wrench size={14} className="text-[var(--accent-primary)]" />
        <span className="flex-1">{t("Repairs in {year}", { year })}</span>
        <b data-testid={`repair-spend-total-${row.property_id}`}>{usd(row.total)}</b>
        {row.jobs.length > 0 && <ChevronDown size={14} className={`faint transition-transform ${open ? "rotate-180" : ""}`} />}
      </button>
      {open && row.jobs.length > 0 && (
        <ul className="px-3 pb-2 text-xs stack-sm" data-testid={`repair-spend-jobs-${row.property_id}`}>
          {row.jobs.map((j, i) => (
            <li key={i} className="flex gap-2"><span className="faint w-12 shrink-0">{day(j.date)}</span><span className="flex-1">{j.business}: {j.work}</span><b>{usd(j.amount)}</b></li>
          ))}
        </ul>
      )}
    </div>
  );
}

export const RepairTotal = ({ data }) => data && (
  <p className="text-sm muted flex items-center gap-2" data-testid="repair-spend-all">
    <Wrench size={14} /> {t("Repair spend in {year}", { year: data.year })}: <b className="text-[var(--text-primary)]">{usd(data.total)}</b>
    {data.unassigned.total > 0 && <span className="faint">· {t("not linked to a property")}: {usd(data.unassigned.total)}</span>}
  </p>
);
